import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Modal, Row } from "reactstrap";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import { Triangle } from "react-loader-spinner";
import { Link } from "react-router-dom";
import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";
import CustomerServices from "../../../services/OrderingServices/CustomerServices";
import CardAssignModal from "../Modal/CardAssignModal";
import CardPaymentService from "../../../services/OrderingServices/CardPaymentService";
import toast from "react-hot-toast";
import RechargeCardModal from "../Modal/RechargeCardModal";
import StatusModal from "../Modal/StatusModal";
import DetailCard from "../Modal/DetailCard";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const CardAssign = ({ customerDetail }) => {
  const [cardAssign, setCardAssign] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isRechargeModalOpen, setIsRechargeModalOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const toggleDetailModal = (row) => {
    setSelectedCard(row);
    setIsDetailModalOpen(!isDetailModalOpen);
  };
  const toggleStatusModal = (row) => {
    setSelectedCard(row);
    setIsStatusModalOpen(!isStatusModalOpen);
  };
  const toggleRechargeModal = (row) => {
    setSelectedCard(row);
    setIsRechargeModalOpen(!isRechargeModalOpen);
  };
  const toggleModal = () => setIsOpen(!isOpen);

  const fetchCardAssign = async () => {
    try {
      setLoading(true);
      const response = await CustomerServices.getCardAssignById(
        customerDetail?.customer?.id,
      );
      setCardAssign(response); // 1 object → convert into array
    } catch (error) {
      console.error("Error fetching card assign:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCardAssign();
  }, []);

  const columns = [
    {
      name: "S.N",
      selector: (_, index) => index + 1,
      width: "60px",
    },
    {
      name: "Card UID",
      selector: (row) => row.cardUid,
      cell: (row) => (
        <span
          className="text-primary"
          style={{ cursor: "pointer" }}
          onClick={() => toggleDetailModal(row)}
        >
          {row.cardUid}
        </span>
      ),
      sortable: true,
    },
    {
      name: "User Name",
      selector: (row) => row.userName,
      sortable: true,
    },
    {
      name: "User Type",
      selector: (row) => row.userType,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <span
          className={`badge text-sm ${
            row.status === "Active"
              ? "bg-success"
              : row.status === "Inactive"
              ? "bg-danger"
              : "bg-warning"
          }`}
        >
          {row.status}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Issued Date",
      selector: (row) => row.issuedDate?.split("T")[0],
    },
    {
      name: "Expiry Date",
      selector: (row) => row.expiryDate?.split("T")[0],
    },
    {
      name: "Issued By",
      selector: (row) => row.issuedBy,
      width: "220px",
    },
    {
      name: "Balance",
      selector: (row) => row.wallet?.balance,
      cell: (row) => <NumberWithCommas number={row.wallet?.balance} />,
      right: true,
    },
    {
      name: "Daily Limit",
      selector: (row) => row.wallet?.dailyLimit,
      right: true,
    },
    {
      name: "Tx Limit",
      selector: (row) => row.wallet?.txLimit,
      right: true,
    },
    {
      name: "Total Recharged",
      selector: (row) => row.wallet?.totalRecharged,
      cell: (row) => <NumberWithCommas number={row.wallet?.totalRecharged} />,
      right: true,
    },
    {
      name: "Total Spent",
      selector: (row) => row.wallet?.totalSpent,
      cell: (row) => <NumberWithCommas number={row.wallet?.totalSpent} />,
      right: true,
    },
    {
      name: "Action",
      cell: (row) => {
        return (
          <div className="d-flex gap-2">
            <Button
              color="success"
              size="sm"
              title="Recharge"
              onClick={() => toggleRechargeModal(row)}
            >
              <i class="ri-wallet-line"></i>
            </Button>
            <Button
              color="info"
              size="sm"
              title="Status"
              onClick={() => toggleStatusModal(row)}
            >
              <i class="ri-pencil-line"></i>
            </Button>
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <Row className="mb-3">
        <Col>
          <Button color="success" className="float-end" onClick={toggleModal}>
            Assign card
          </Button>
        </Col>
      </Row>

      <Card>
        <CustomDataTable
          responsive
          striped
          pagination
          fixedHeader
          persistTableHead
          progressPending={loading}
          customStyles={customStyles}
          progressComponent={
            <div className="my-3 text-center">
              <Triangle visible height="80" width="80" color="#5B71B9" />
              <h5 className="mt-1">Loading...</h5>
            </div>
          }
          columns={columns}
          data={cardAssign}
        />
      </Card>

      <CardAssignModal
        isOpen={isOpen}
        toggle={toggleModal}
        customerDetail={customerDetail}
        fetchCardAssign={fetchCardAssign}
      />
      <RechargeCardModal
        isOpen={isRechargeModalOpen}
        toggle={toggleRechargeModal}
        selectedCard={selectedCard}
        fetchCardAssign={fetchCardAssign}
      />
      <StatusModal
        isOpen={isStatusModalOpen}
        toggle={toggleStatusModal}
        selectedCard={selectedCard}
        fetchCardAssign={fetchCardAssign}
      />
      <DetailCard
        isOpen={isDetailModalOpen}
        toggle={toggleDetailModal}
        selectedCard={selectedCard}
      />
    </div>
  );
};

export default CardAssign;
